
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5.29473 15.9254L21.7812 11.195C22.5776 10.9665 23.0396 10.1375 22.815 9.34002C22.5882 8.53519 21.749 8.06938 20.9461 8.30271L15.6805 9.83282L8.65129 3.51855L6.73235 4.08421L11.0089 11.1825L6.08063 12.596L4.08619 11.095L2.63694 11.514L5.29473 15.9254ZM21.7832 11.1835C21.7816 11.184 21.78 11.1845 21.7784 11.185L21.7832 11.1835ZM3.5 19.0001C2.94771 19.0001 2.5 19.4478 2.5 20.0001C2.5 20.5524 2.94772 21.0001 3.5 21.0001H20.5C21.0523 21.0001 21.5 20.5524 21.5 20.0001C21.5 19.4478 21.0523 19.0001 20.5 19.0001H3.5Z","fill":"#262D33"}})])
          )
        }
      }
    